
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import rulesHandler from '@/rulesHandler';
import IllinoisCollapsible from './Collapsible.vue';
import { formatSecondsToTimeWithMinutes } from '@/composables/utils';
import { LiveEventsCountResult } from '../../../../types/sport';
import FieldStatistics from './Stats/FieldStatistics.vue';
import icons from './icons.vue';
import EventItem from './EventItem.vue';
import EventGroup from './EventGroup.vue';
import { LiveEventsEvent, PreviewEventGroup } from '../../../../types/sport';

export default Vue.extend({
  name: 'LiveTrackerIllinois',
  components: {
    IllinoisCollapsible,
    FieldStatistics,
    icons,
    EventItem,
    EventGroup
  },
  props: {},
  data() {
    return {
      notExistsSportUuid: false as boolean,
      sportUuid: null as string | null
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage'
    }),
    selectedSportId() {
      return this.$store.getters['IllinoisSport/getActiveLiveSport'];
    },
    sportId() {
      return this.selectedSportId
        ? this.selectedSportId
        : this.$route.params.sportId
        ? this.$route.params.sportId
        : null;
    },
    windowWidth() {
      return window.innerWidth;
    },
    windowHeight() {
      return this.windowWidth > 950
        ? window.innerHeight - 70
        : window.innerHeight - 44;
    },

    eventSelected() {
      return this.$route.params.eventId ? this.$route.params.eventId : null;
    },
    eventDetail() {
      return this.$store.getters['IllinoisSport/getLiveEventById'](
        this.eventSelected
      );
    },
    rules() {
      return this.$store.getters['IllinoisSport/getStatsIframesRulesMap'];
    },
    configuration() {
      if (!this.sportId) return null;
      const rule = this.rules[this.sportId.toString()];
      if (!rule) return null;
      return rule.configuration;
    },
    sport() {
      return this.configuration ? this.configuration.split('/')[2] : null;
    },

    url() {
      if (!this.sportUuid || !this.configuration) {
        return null;
      }
      const splitString = this.configuration.split('/');

      const baseUrl = splitString[0];

      const version = splitString[1];

      const profileId = splitString[3];
      return baseUrl && version && profileId && this.sportUuid
        ? 'https://' +
            baseUrl +
            '/' +
            this.getLanguage +
            '/' +
            version +
            '/' +
            this.sport?.toString() +
            '?profile=' +
            profileId +
            '&uuid=' +
            this.sportUuid?.toString()
        : null;
    },
    liveEventsBySport() {
      return this.$store.getters['IllinoisSport/getLiveEventsBySport'](
        this.sportId
      );
    },
    liveEventsBySportFiltered() {
      if (!this.liveEventsBySport?.groupedEvents) {
        return [];
      }
      if (!this.eventSelected) {
        return this.liveEventsBySport;
      }
      const eventSelectedId = Number(this.eventSelected);
      const groupedEvents = this.liveEventsBySport.groupedEvents
        .map((group: LiveEventsEvent[]) =>
          group.filter((event: LiveEventsEvent) => event.id !== eventSelectedId)
        )
        .filter((group: LiveEventsEvent[]) => group.length > 0);
      return {
        ...this.liveEventsBySport,
        groupedEvents
      };
    },
    firstEvent() {
      return this.liveEventsBySport?.groupedEvents[0][0];
    },
    loading() {
      return this.$store.getters['IllinoisSport/getLoadingLive'];
    },
    isLoadingData() {
      // Se non c'è sportId, non possiamo sapere se sta caricando
      if (!this.sportId) {
        return this.loading;
      }
      // Se liveEventsBySport non esiste per questo sportId, il caricamento è ancora in corso
      if (!this.liveEventsBySport) {
        return true;
      }
      // Se esiste, il caricamento è finito
      return false;
    },
    hasEvents() {
      // Se non c'è liveEventsBySport, non ci sono eventi
      if (!this.liveEventsBySportFiltered) {
        return false;
      }
      // Verifica se ci sono groupedEvents con eventi
      const groupedEvents = this.liveEventsBySportFiltered.groupedEvents;
      if (!groupedEvents) {
        return false;
      }
      return (
        Array.isArray(groupedEvents) &&
        groupedEvents.length > 0 &&
        groupedEvents.some(
          (group: LiveEventsEvent[]) => Array.isArray(group) && group.length > 0
        )
      );
    }
  },
  methods: {
    ...mapActions({
      getEventIdLiveTracker: 'odds/getEventIdLiveTracker'
    }),
    onResize() {
      /* this.windowHeight = window.innerHeight; */
      console.log('onResize', this.windowWidth);
    },
    t(key: string, values?: Record<string, unknown> | any[]) {
      return this.$t(key, values) as string;
    },
    formatSecondsToTimeWithMinutes,
    getCurrentPeriod(period: any[]) {
      if (!Array.isArray(period) || period.length === 0) {
        return '';
      }
      const find = period.find((p: any) => p.lang === this.getLanguage);
      if (find) {
        return find.text || '';
      }
      const findEn = period.find((p: any) => p.lang === 'en');
      if (findEn) {
        return findEn.text || '';
      }
      return '';
    },
    async fetchSportUuid(this: any): Promise<void> {
      if (!this.eventSelected || !this.sport) {
        this.sportUuid = null;
        return;
      }
      const res = await this.getEventIdLiveTracker({
        matchId: this.eventSelected.toString(),
        sport: this.sport.toString()
      });
      this.sportUuid = res?.data?.sportUuid || null;
    }
  },
  watch: {
    eventSelected: {
      handler(this: any) {
        this.fetchSportUuid();
        if (this.eventSelected) {
          this.$store.dispatch('IllinoisSport/setFieldStatisticsEventId', {
            eventId: this.eventSelected
          });
        }
      },
      immediate: true
    },
    sportId: {
      handler(this: any) {
        if (this.sportId) {
          this.$store.dispatch('IllinoisSport/setFieldStatisticsSportId', {
            sportId: this.sportId
          });
        }
      },
      immediate: true
    },
    sport: {
      handler(this: any) {
        this.fetchSportUuid();
      },
      immediate: true
    }
  },
  async mounted() {
    window.addEventListener('resize', this.onResize, {
      passive: true
    });
    await this.$store.dispatch(
      'IllinoisSport/fetchAndStoreStatsIframesRulesMap'
    );
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
});
